/**
 * Переводы значений опций фильтров (канонические значения из БД).
 * Ключ = каноническая строка, значение = текст для отображения.
 */
export default {
  'Продажа': 'Продажа',
  'Аренда': 'Аренда',
  'Аренда долгосрочная': 'Аренда долгосрочная',
  'Обмен': 'Обмен',
  'Квартиры': 'Квартиры',
  'Дома': 'Дома',
  'Земля': 'Земля',
  'Гаражи / стоянки': 'Гаражи / стоянки',
  'Коммерческие помещения': 'Коммерческие помещения',
  'От застройщика': 'От застройщика',
}
